import React, { useEffect } from "react";
import LazyLoad from "react-lazyload";
import { Link } from "react-router-dom";
const OurSchool = () => {
  useEffect(() => {
    document.title =
      "Our School - Mar Gregorios Memorial Hr. Sec. School, Bokaro";
  }, []);
  return (
    <>
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>{" "}
          </li>
          <li> School</li>
          <li>Our School</li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1>Our School </h1>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="clearfix">
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/Images/our_school.jpg"
                    alt=""
                    className="col-lg-5 col-md-6 float-md-end  left-img img-fluid"
                  />
                </LazyLoad>
                <p>
                  M.G.M. (acronym for Mar Gregorios Memorial) Higher Secondary
                  School, Bokaro Steel City is one of the best English Medium
                  Co-Education Institutions under the aegis of the Calcutta
                  Diocesan Council of the Indian Orthodox Church. Late Lamented
                  his Grace Dr. Stephanos Mar Theodosius, an eminent
                  educationist, was the Founder President of this school. Rev.
                  Fr. O. Thomas was the founder Principal of this institution
                  with whose hard work and vision resulted in the establishing
                  of this prestigious intuition. The Great Scholar, H. G.
                  Alexios Mar Eusebius is the current President of the school.
                  We have thirty two distinct educational institutions spread in
                  various States from Nagpur to Arunachal Pradesh under Calcutta
                  Diocese of the Indian Orthodox Church. The School building is
                  located in a sprawling campus spread out in 08 acres of land
                  granted by the Management of Bokaro Steel Limited in the year
                  1986 on lease. At present the school campus accommodates a
                  primary wing and a secondary wing functioning from Classes I
                  to XII with an approximate strength of above 3210 students. We
                  have the privilege to state that the school is graced to have
                  professionally qualified, dedicated and experienced teaching
                  staffs fitting into the aspirations and expectations of the
                  students and their parents. The school is affiliated to the
                  CBSE Board, Under Patna Region.
                </p>
                <p>
                  The school is known for its Eco-friendly campus and is awarded
                  by CED Foundation as Five Star Rated School of India for Green
                  School Initiative. The school is having well-furnished class
                  rooms, well equipped modern science laboratories, four
                  computer labs, sprawling well stocked libraries, audio visual
                  Lecture Theater rooms, conference hall, Multipurpose Hall,
                  Atal Tinkering Lab, Language Lab, Digital Class rooms,
                  internet connection with broad band facility, Diesel Generator
                  set facility for alternate and uninterrupted power supply,
                  Wi-Fi campus, Extra Marks Smart Classes with DTS Technology,
                  school automation software Entab Campus Care for online
                  solutions, Career &amp; Counseling Department and Dynamic
                  Website.{" "}
                </p>
                <p>
                  The school is having a campus counter of the Central Bank of
                  India &amp; had tied up with Federal Bank city branch for easy
                  fee deposits. The campus is having an ATM counter of Federal
                  Bank for easy money withdrawals. The school is providing
                  online payment facility through payment gateway and online
                  admission facility through robust school ERP Campus Care. A
                  separate Administrative Block, spacious and extensive
                  Playgrounds, hygienic canteen for students and staff and staff
                  quarters are some of the additional features of the school.
                </p>
                <p>
                  Our leading sister concern, St. Mary's Nursery School, located
                  in a separate campus in the Steel City and established in the
                  year 1976, have carved out a separate niche of its own from
                  where the concept of M.G.M came into existence. It has
                  strength of nearly 500+ Children attending classes from
                  Nursery to U. K. G. The school follows the Play Way Mix Match
                  method to train the little scholars. St. Mary's Nursery School
                  serves as a tributary stream to our School. The first Batch of
                  Gregorians of class X passed out the CBSE Board Examination in
                  the year 1995 – 96 and class XII in the year 1997 – 98. Since
                  then the School has made exemplary strides in the field of
                  education and figured prominent among schools of Bokaro Steel
                  City . Master Prabhat Ranjan brought glory to the School and
                  the City in the Year 2004 by bagging the All India Second Rank
                  in the CBSE Board Examination. Miss. Shefali Agarwal has
                  secured top position in CBSE Board Examination of Jharkhand
                  State in the year 2010 – 2011. Similarly, the school has been
                  ranked as 2nd best in the State of Jharkhand for AIEEE
                  Examination for the year 2012. Sports is another arena where
                  we have excelled. The Girls Team in Basket Ball competing in
                  the C.B.S.E. Cluster II was Champion for four Consecutive
                  Years. The School has hosted CBSE Basket Ball Cluster several
                  times. The school is also having an excellent cricket,
                  football, volleyball, rope skipping, judo, karate and table
                  tennis team. Ms. Anku Kumari of our school bagged 3 Gold in
                  Archery at CBSE Nationals 2018. Tripti Jha and Sneha Kumari
                  represented Jharkhand Team in Lagori Game at 37th National
                  Games Goa in 2023. M.G.M students are continuously
                  representing Khelo India, Youth Games and SGFI in games like
                  Gatka, Judo, Lagori etc. The school is having four clubs and
                  four houses with round the clock activities and projects. The
                  school also have an excellent CBSE X and XII results every
                  year. The school is also having a vibrant Alumni by name BAAG.
                </p>
                <p>
                  {" "}
                  M.G.M Bokaro is a Skill Hub Centre of Pradhan Mantri Kaushal
                  Vikas Yojana for training Computer skill, Photography, Sound
                  Editing and Journalism. As a part of our social commitment,
                  the school is running a free school by name MGM Balwadi from
                  nursery to class V for poor students of village Lakdakhanda,
                  Bokaro for last 31 years.
                </p>
                <p>
                  <strong>
                    Our aim is to design and fashion well-groomed social beings
                    with positive attitude and good human values besides
                    excellence in academics.
                  </strong>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OurSchool;
